
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"40","height":"40"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Grupo 369","transform":"translate(-238 -137.88)"}},[_c('circle',{attrs:{"data-name":"Elipse 26","cx":"20","cy":"20","r":"20","transform":"translate(238 137.88)","fill":"#0f587f"}}),_c('g',{attrs:{"data-name":"Grupo 253","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"data-name":"Rectángulo 229","fill":"#fff","stroke":"#fff","d":"M250.651 161.51l9.523-9.522 4.076 4.077-9.522 9.522z"}}),_c('path',{attrs:{"data-name":"Rectángulo 230","fill":"#0f587f","stroke":"#0f587f","d":"M254.5 161.657l5.82-5.82.082.081-5.82 5.82z"}}),_c('path',{attrs:{"data-name":"Trazado 144","d":"M266.886 150.718l-1.366-1.365a1.917 1.917 0 00-2.711 0l-1.265 1.265 4.077 4.073 1.265-1.262a1.917 1.917 0 000-2.71","fill":"#fff","stroke":"#fff"}}),_c('path',{attrs:{"data-name":"Trazado 145","d":"M251.36 164.958l2.039 2.04-2.28.241-2.28.241.242-2.28.24-2.28z","fill":"#fff","stroke":"#fff"}})])])])
          )
        }
      }
    